import React, { FC } from 'react'

import { IResourceListItemProps, ResourceListItem } from './ResourceListItem'
import Table, { TableBody } from '../../../components/common/table/Table'
import './ResourceList.less'
import { MoveResourceModal } from '../../workspace-page/components/move-resource-modal/MoveResourceModal'
import { useModal } from 'front-end/src/app/hooks/useModal'
import { SortableContainer, SortableElement } from 'react-sortable-hoc'
import { useSortableTopics } from './useSortableTopics'
import { Box } from '@chakra-ui/react'

export interface ResourceListProps {
  resources: Array<
    Omit<IResourceListItemProps, 'onMove' | 'showSelection' | 'refetchTopics'>
  >
  showSelection: boolean
  themeId?: number
  workspaceId: number
  refetchTopics: () => Promise<any>
  rearrangeResources: (resourcesIds: number[]) => Promise<unknown>
}

export const ResourceList: FC<ResourceListProps> = (props) => {
  const { open, currentModal } = useModal()
  const { resources: sortedResources, handleSortEnd } = useSortableTopics(
    props.resources,
    props.refetchTopics,
    props.rearrangeResources
  )

  return (
    <div className="ResourceList">
      <Table className="ResourceListTable">
        <TableBody>
          <SortableDiv
            lockAxis="y"
            useDragHandle
            onSortEnd={handleSortEnd}
            helperClass="dragging"
          >
            {sortedResources &&
              sortedResources.map((topic, idx) => (
                <SortableResourceListItem
                  index={idx}
                  key={topic.id}
                  {...topic}
                  showSelection={props.showSelection}
                  refetchTopics={props.refetchTopics}
                  onMove={(topic) =>
                    open(MoveResourceModal, {
                      topicId: topic.id,
                      currentlyIn: {
                        themeId: props.themeId,
                        workspaceId: props.workspaceId
                      }
                    }).then(props.refetchTopics)
                  }
                />
              ))}
          </SortableDiv>
        </TableBody>
      </Table>

      {currentModal}
    </div>
  )
}

const SortableDiv = SortableContainer((props) => <Box {...props} />)
const SortableResourceListItem = SortableElement(ResourceListItem)
